import * as React from 'react'
import classNames from 'classnames'
// import { ContentfulGrid, Maybe } from '../../types/graphql-types'
import styleClasses from './widget-grid.module.scss'

const xsMap = [undefined, styleClasses.xs1, styleClasses.xs2, styleClasses.xs3, styleClasses.xs4]
const smMap = [undefined, styleClasses.sm1, styleClasses.sm2, styleClasses.sm3, styleClasses.sm4]
const mdMap = [undefined, styleClasses.md1, styleClasses.md2, styleClasses.md3, styleClasses.md4]
const lgMap = [undefined, styleClasses.lg1, styleClasses.lg2, styleClasses.lg3, styleClasses.lg4]

export type WidgetGridProps = {
  grid?: GatsbyTypes.Maybe<GatsbyTypes.gridLeafFragment>
}

const WidgetGrid: React.FC<WidgetGridProps> = ({ grid, children }) => {
  if (!grid) return null
  const { xsCols, smCols, mdCols, lgCols } = grid
  return (
    <div className={classNames(styleClasses.grid, xsMap[xsCols || 0], smMap[smCols || 0], mdMap[mdCols || 0], lgMap[lgCols || 0])}>
      {children}
    </div>
  )
}

export default WidgetGrid
